<div id="analytics-container" *loading="loadStatus">
    <mat-accordion>
        <ng-container  *ngIf="course">
            <mat-expansion-panel class="scene-container room3D-container mat-elevation-z0" expanded="true">
                <mat-expansion-panel-header class="mat-elevation-z1">
                    <contents-stat-item [data]="get3DRoomData()" ></contents-stat-item>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <annotations-stats  [annotations]="getRoom3DAnnotations()" [sceneUsersCount]="getRoom3DUsersCount()" [date_from]="date_from" [date_to]="date_to"></annotations-stats>
                </ng-template>
            </mat-expansion-panel>
        </ng-container>
        <ng-container *ngIf="course">
                <ng-container *ngFor="let section of course.sections">
                    <h3 class="section-title"><img class="section-icon" src="assets/wonda/ui-presentation-black.png" /><span>{{ section.title }}</span></h3>
                    <ng-container *ngIf="section.scenes">
                        <ng-container *ngFor="let scene of section.scenes">
                            <mat-expansion-panel class="scene-container mat-elevation-z0">
                                <mat-expansion-panel-header class="mat-elevation-z1">
                                    <contents-stat-item  [data]="getSceneData(scene.id)" ></contents-stat-item>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <annotations-stats  [annotations]="getSceneAnnotations(scene.id)" [sceneUsersCount]="getSceneViewCount(scene.id)" [date_from]="date_from" [date_to]="date_to"></annotations-stats>
                                </ng-template>
                            </mat-expansion-panel>
                        </ng-container>
                    </ng-container>
                </ng-container>
        </ng-container>
    </mat-accordion>
</div>

